export const data1 = [
    {
        productId: 14692433133935,
        variantId: 51919145959791,
        staticImg: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745286655157/1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745286650760/1-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745286650760/1-h5.jpg',
        },
    },
];

export const data2 = [
    {
        productId: 14689202667887,
        variantId: 51927572021615,
        staticImg: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745286654164/2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745286654421/2-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745286654421/2-h5.jpg',
        },
    },
];

export const data3 = [
    {
        productId: 14695816069487,
        variantId: 51927575560559,
        staticImg: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745286653698/3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745286654037/3-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745286654037/3-h5.jpg',
        },
    },
    {
        productId: 14696915075439,
        variantId: 51927575789935,
        staticImg: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745286653238/4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745286653466/4-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745286653466/4-h5.jpg',
        },
    },
    {
        productId: 14694862815599,
        variantId: 51927575986543,
        staticImg: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745286651888/5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745286653085/5-h6.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745286653085/5-h6.jpg',
        },
    },
    {
        productId: 14695837630831,
        variantId: 51927670456687,
        staticImg: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745286651888/5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745286653085/5-h6.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745286653085/5-h6.jpg',
        },
    },
    {
        productId: 14695060210031,
        variantId: 51927582966127,
        staticImg: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745286651196/6.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745286651600/6-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745286651600/6-h5.jpg',
        },
    },
];
